// extracted by mini-css-extract-plugin
export default {"Container":"Gallery_Container__jDhYs","image":"Gallery_image__bjkG7","hovercap":"Gallery_hovercap__xZffn","wrapper":"Gallery_wrapper__hVBS-"};